import { createCooldownController } from '@/components/otc/otcCooldown'

// Shared 30-second OTC "send code" cooldown, backed by otcCooldown.js's pure cooldown controller.
// Used by every screen with a "send code" button (MemberIdentityVerification.vue,
// MemberChangePassword.vue, MemberChangeLoginId.vue, ResetPassword.vue) - each component's own
// handleSendVerificationCode still handles its own OTC-dispatch call independently.
// No countdown is shown (client request): each screen disables its 「コード送信」 button while
// verificationCodeCooldown > 0 and shows a static 「再送信可能まで30秒」 note instead.
export default {
  data () {
    return {
      verificationCodeCooldown: 0,
      verificationCodeTimerId: null
    }
  },
  beforeDestroy () {
    if (this.verificationCodeTimerId) {
      clearInterval(this.verificationCodeTimerId)
    }
  },
  methods: {
    startVerificationCodeCooldown () {
      const cooldown = createCooldownController(30)
      cooldown.start(Date.now())
      this.verificationCodeCooldown = cooldown.remainingSeconds(Date.now())
      if (this.verificationCodeTimerId) {
        clearInterval(this.verificationCodeTimerId)
      }
      this.verificationCodeTimerId = setInterval(() => {
        this.verificationCodeCooldown = cooldown.remainingSeconds(Date.now())
        if (this.verificationCodeCooldown <= 0) {
          clearInterval(this.verificationCodeTimerId)
          this.verificationCodeTimerId = null
        }
      }, 1000)
    }
  }
}
